<div class="bulb-image-asset bulb-credit-position bulb-image-asset--opacity"
  bulbResizeObserver
  (resized)="onResize($event)"
  [ngClass]="{'bulb-carousel-display': isImageCarousel}"
  [bulbImageFade]="isEditingPage">
  <div [id]="imageCreditId" class="bulb-internal-credit-position">
    <div *ngIf="showPlaceholder && source === 'ckeditor'" class="bulb-image-render-placeholder"></div>
    <img [attr.image-id]="imageId"
     [ngStyle]="{height: imageHeight}"
     [src]="imageAsset.url"
     [ngClass]="{'circular-image': creditType === 'CIRCULAR'}"
     draggable="false"
     role="presentation"
     loading="lazy"
     (load)="imageLoaded()"/>
     <ng-container *ngIf="showCredit">
      <div [hidden]="showCreditIcon"
         class="bulb-image-view">
        <div [ngSwitch]="creditType">
          <!-- Show credit info in circular form -->
          <div *ngSwitchCase="'CIRCULAR'"
             class="bulb-image-circular">
          <span>
            <svg viewBox="12 12 290 290"
               xmlns:xlink="http://www.w3.org/1999/xlink">
              <g transform="translate(160,160)">
                <!-- Text manipulation starts here: -->
                <text>
                  <textPath xlink:href="#cp2"
                        path="M-120 0A120 130 0 0 0 130 0"
                        startOffset="70%"
                        text-anchor="middle"
                        dominant-baseline="central"
                        fill="white">
                    <a xlink:href=""
                       [attr.href]="creditInfo.photographerProfileUrl"
                       target="_blank"
                       fill="white">
                      {{creditInfo.photographerName}} {{'assetlibrary_on_text' | translate}}
                    </a>
                    <a xlink:href=""
                       [attr.href]="creditInfo.sourceUrl"
                       target="_blank"
                       fill="white">
                      {{creditInfo.source}}
                    </a>
                  </textPath>
                </text>
              </g>
            </svg>
          </span>
          </div>
          <!-- Show credit info in standard form -->
          <span *ngSwitchDefault
              class="bulb-image-block-caption">
            <!-- These span contents are intentionally written to prevent new lines in the CDATA so it won't be
            converted into white space in the rendered text -->
            <a target="_blank"
               [href]="creditInfo.photographerProfileUrl">
              {{creditInfo.photographerName}}
            </a>
            {{'assetlibrary_on_text' | translate}}
            <a target="_blank"
               [href]="creditInfo.sourceUrl">
              {{creditInfo.source}}
            </a>
          </span>
        </div>
      </div>
      <div [hidden]="!showCreditIcon"
         class="bulb-tooltip-image-view">
        <span>
          <a class="bulb-image-tooltip-text"
             aeroTooltip="{{creditInfo.photographerName}}
            {{'assetlibrary_on_text' | translate}} {{creditInfo.source}}"
             aeroTooltipPosition="left"
             target="_blank"
             [href]="creditInfo.photographerProfileUrl">
          </a>
        </span>
      </div>
    </ng-container>
  </div>
</div>
